export default __webpack_public_path__ + "static/media/logo.1fd11a65.png";